import React from "react";
import styles from "./DashboardHeaderLabel.module.scss";
export default () => React.createElement("div", { className: styles.label }, "Your Dashboard");
